<script setup lang="ts">
import type { Dashboard, DashboardComponent } from '@/dashboards/domain/dashboard';
import { DashboardComponentType } from 'shared/dashboards/domain/dashboardComponentType';
import StorageAreaTable from './types/StorageAreaTable.vue';
import LatestReleaseNotes from './types/LatestReleaseNotes.vue';
import ProductGroupDiagram from './types/ProductGroupDiagram.vue';
import ProductGroupTable from './types/ProductGroupTable.vue';
import ProductTable from './types/ProductTable.vue';
import AsljungapallenLagersaldo from './types/AsljungapallenLagersaldo.vue';

const dashboard = defineModel<Dashboard>('dashboard', { required: true });

function getGridColumn(component: DashboardComponent) {
  const from = component.x + 1;
  const to = from + component.width;
  return `${from}/${to}`;
}

function getGridRow(component: DashboardComponent) {
  const from = component.y + 1;
  const to = from + component.height;
  return `${from}/${to}`;
}

function getComponent(component: DashboardComponent) {
  switch (component.type) {
    case DashboardComponentType.StorageAreaTable:
      return StorageAreaTable;
    case DashboardComponentType.LatestReleaseNotes:
      return LatestReleaseNotes;
    case DashboardComponentType.ProductGroupTable:
      return ProductGroupTable;
    case DashboardComponentType.ProductGroupDiagram:
      return ProductGroupDiagram;
    case DashboardComponentType.ProductTable:
      return ProductTable;
    case DashboardComponentType.AsljungapallenLagersaldo:
      return AsljungapallenLagersaldo;
  }
}
</script>

<template>
  <div class="component-grid">
    <div
      class="grid-design"
      v-for="component in dashboard.components"
      v-bind:key="component.id"
      :style="{
        gridRow: getGridRow(component),
        gridColumn: getGridColumn(component),
        overflowY: 'hidden',
      }"
    >
      <component :is="getComponent(component)"></component>
    </div>
  </div>
</template>

<style scoped>
.component-grid {
  height: 100%;
  gap: 0.5rem;
  overflow-y: hidden;
  display: grid;
}
.grid-design {
  margin: 5px;
  padding: 1rem 2rem 2rem 2rem;
  overflow: hidden;
  border: 1px solid rgb(227, 227, 227);
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
</style>
